import FadeUp from "./FadeUp";
import { DEST_IMAGES } from "../data/images";

const TILES = [
  DEST_IMAGES.indore.card,
  DEST_IMAGES.ujjain.card,
  DEST_IMAGES.bhopal.card,
  DEST_IMAGES.maheshwar.card,
  DEST_IMAGES.omkareshwar.card,
  DEST_IMAGES.pachmarhi.card,
];

export default function InstagramGrid() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <div className="mb-10 text-center">
            <p className="section-label justify-center">← Follow Us →</p>
            <h2 className="heading-xl text-3xl sm:text-4xl">@jsrtravels on Instagram</h2>
          </div>
        </FadeUp>

        <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
          {TILES.map((src, i) => (
            <FadeUp key={src} delay={i * 0.06}>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-square overflow-hidden rounded-2xl"
              >
                <img
                  src={src}
                  alt="JSR Travels gallery"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-navy/0 transition-colors duration-300 group-hover:bg-navy/25" />
              </a>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
